export enum SkeletonType {
  HUMANOID = 1, // 人形骨骼
  FISH, // 鱼类骨骼
  REPTILIA, // 爬行类骨骼
  BIRD, // 鸟类骨骼
  SNAKE, // 蛇类骨骼
  SIMPLE, // 简易骨骼
  BLANK, // /
  NOT, // 无骨骼
  SURFACE, // 地面
}
